import { Box, Typography } from "@mui/material";
import { Trans } from "@lingui/macro";
import dynamic from "next/dynamic";

const RegisterLogo1 = dynamic(() => import("@/components/svg/register/register-logo-1"));
const RegisterLogo2 = dynamic(() => import("@/components/svg/register/register-logo-2"));
const RegisterLogo3 = dynamic(() => import("@/components/svg/register/register-logo-3"));

const Advantages: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: {
            xs: "20px",
            ms: "15px",
          },
        }}
      >
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Box sx={{ width: "28px" }}>
            <RegisterLogo1 />
          </Box>
          <Typography>
            <Trans>Receive voucher instantly</Trans>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Box sx={{ width: "28px" }}>
            <RegisterLogo2 />
          </Box>
          <Typography>
            <Trans>The largest voucher assortment in Switzerland</Trans>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Box sx={{ width: "28px" }}>
            <RegisterLogo3 />
          </Box>
          <Typography>
            <Trans>Completely digital and environmentally conscious</Trans>
          </Typography>
        </Box>
      </Box>
    </>
  );
};
export default Advantages;
